import Rest from '@services/Rest';

/**
 * @typedef {SalesBannersProxyService}
 */
export default class SalesBannersProxyService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/sales/banners'
}
